<template>
  <v-field class="mb-5" :error="errors['agree']">
    <label class="flex items-start rounded-lg bg-gray-50 px-3 py-3 text-[13px] leading-6 text-gray-600">
      <input
        type="checkbox"
        @change="$emit('input', $event.target.checked)"
        class="mr-2 mt-1 flex-none rounded border-gray-300 text-primary"
      />
      <span>
        本人已閱讀、了解並同意接受
        <nuxt-link to="/teams/policies/refund" class="underline text-primary"
          >《退換政策》</nuxt-link
        >、
        <nuxt-link to="/teams/policies/service" class="underline text-primary"
          >《{{ app }}網站用戶註冊協議》</nuxt-link
        >和
        <nuxt-link to="/teams/policies/privacy" class="underline text-primary"
          >《隱私政策》</nuxt-link
        >之所有內容及其後之修改變更。
      </span>
    </label>
  </v-field>
</template>

<script>
export default {
  computed: {
    app() {
      return this.$store.getters['app/info']?.name || process.env.APP_NAME;
    }
  }
};
</script>

<style lang="scss" scoped></style>
